import { render } from "./AddressFieldGroup.vue?vue&type=template&id=e7c17a92"
import script from "./AddressFieldGroup.vue?vue&type=script&lang=js"
export * from "./AddressFieldGroup.vue?vue&type=script&lang=js"
script.render = render

export default script